class ReviewSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.section-reviews-slider');
    if (!swiperEl) return;

    // Initialize Swiper
    this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
          600: { slidesPerView: 1.6,spaceBetween: 22, },
          768: { slidesPerView: 2.2,spaceBetween: 22, },
          989: { slidesPerView: 3,spaceBetween: 22, }
        }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

customElements.define('review-slider', ReviewSlider);